/* Cart Upsell YMAL — delegated events on document, safe across DOM replacement */
(function () {
  'use strict';

  /* ── Arrow scroll ──────────────────────────────────────── */
  document.addEventListener('click', function (e) {

    /* Prev arrow */
    if (e.target.closest('.ymal-prev')) {
      var section = e.target.closest('.ymal-section') ||
                    document.getElementById('ymal-section');
      var track = section && section.querySelector('.ymal-track');
      if (track) track.scrollBy({ left: -170, behavior: 'smooth' });
      return;
    }

    /* Next arrow */
    if (e.target.closest('.ymal-next')) {
      var section = e.target.closest('.ymal-section') ||
                    document.getElementById('ymal-section');
      var track = section && section.querySelector('.ymal-track');
      if (track) track.scrollBy({ left: 170, behavior: 'smooth' });
      return;
    }

    /* ── Add to Cart button ─────────────────────────────── */
    var btn = e.target.closest('.ymal-atc[data-ymal-vid]');
    if (!btn || btn.disabled || btn.classList.contains('ymal-busy')) return;

    var vid = btn.getAttribute('data-ymal-vid');
    if (!vid) return;

    btn.classList.add('ymal-busy');
    btn.textContent = 'Adding…';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: parseInt(vid, 10), quantity: 1 })
    })
    .then(function (r) {
      if (!r.ok) throw new Error('Cart add failed: ' + r.status);
      return r.json();
    })
    .then(function () {
      btn.classList.remove('ymal-busy');
      btn.classList.add('ymal-ok');
      btn.textContent = 'Added ✓';

      /* Update cart count badge if theme exposes it */
      fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var badges = document.querySelectorAll('[data-cart-count],[data-header-cart-count],.cart-count,.header__cart-count');
          badges.forEach(function (el) { el.textContent = cart.item_count; });
          /* Fire theme cart refresh event */
          document.dispatchEvent(new CustomEvent('cart:refresh', { detail: cart }));
        });

      /* Refresh [data-line-items] via the theme's own section endpoint */
      var root = (window.theme && window.theme.routes && window.theme.routes.root_url) || '/';
      fetch(root + '?section_id=api-cart-items')
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('[data-api-content]');
          var lineItems = document.querySelector('[data-line-items]');
          if (fresh && lineItems) {
            lineItems.innerHTML = fresh.innerHTML;
          }
        });

      setTimeout(function () {
        /* btn may have been replaced by the reload above; that's fine */
        if (document.contains(btn)) {
          btn.classList.remove('ymal-ok');
          btn.textContent = 'Add to Cart';
        }
      }, 2500);
    })
    .catch(function (err) {
      console.error('[YMAL] cart add error:', err);
      btn.classList.remove('ymal-busy');
      btn.textContent = 'Add to Cart';
    });
  });

})();
